import Elemento from "./Elemento.js";

export default class Grupo extends Elemento {
  constructor() {
    super();
    this.position;
    this.campos = new Array();
    this.hotSpot = true;

    this.EsError = function (perfil) {
      var status = false;

      this.campos.forEach((campo) => {
        status = status || campo.EsError(perfil);
      });

      return status;
    };
  }
}
